var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.obj_to_null(this.field)
    ? _c("div", { staticClass: "action_field in_memor" }, [
        _c("div", { staticClass: "field_insert small" }, [
          _vm._v(_vm._s(_vm.field.number)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert small tdtp" }, [
          _vm._v(_vm._s(_vm.field.tdtp)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold small kp" }, [
          _vm._v(_vm._s(_vm.field.kp_code)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert main_big" }, [
          _vm._v(_vm._s(_vm.field.dolznost)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold big" }, [
          _vm._v(_vm._s(_vm.field.qual_shtat)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert big" }, [
          _vm._v(_vm._s(_vm.field.hour_stavka)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold medium mpo" }, [
          _vm._v(_vm._s(_vm._f("toNiceNumber")(_vm.field.month_money))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert small" }, [
          _vm._v(_vm._s(_vm.field.is_bad)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert big" }, [
          _vm._v(_vm._s(_vm.field.doplata)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold medium" }, [
          _vm._v(_vm._s(_vm.field.max_doplata)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold medium mpo" }, [
          _vm._v(_vm._s(_vm._f("toNiceNumber")(_vm.field.all_money))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold medium" }, [
          _vm._v(_vm._s(_vm._f("toNiceNumber")(_vm.field.do_vupl))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field_insert bold medium last-child" }, [
          _vm._v(_vm._s(_vm._f("toNiceNumber")(_vm.field.all_fop))),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }